import  React,{ useEffect, useMemo, useState } from "react";
import Modal from "react-modal";
// import Modal from "react-responsive-modal";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { GetPickupDate } from "../../api/PickupApi";
import useDeviceIos from "../../hooks/useDeviceIos";
import useMobile from "../../hooks/useMobile";
import {
  deliveryScheduleAsapArr,
  setDeliveryScheduleType,
  setSelectedPickupDate,
  setSelectedPickupTime,
} from "../../redux/features/CheckoutAddress";
import {
  convertToMinutes,
  convertToMinutesIphone,
  ReturnStoreAddress,
} from "../../utils/helper";
import Konsole from "../../utils/konsole/Konsole";
const DeliveryOption = ({ orderType }: { orderType: string }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // @@ check device is ios or not
  const isDeviceIos = useDeviceIos();
  const iosDevice = useDeviceIos();
  const mobile = useMobile();

  // const selectDayRef = useRef<any>(null);

  const storeInfo = useSelector((state: any) => state?.store);
  const { selectedPickupDate, selectedPickupTime, deliveryScheduleType } =
    useSelector((state: any) => state?.checkoutAddress);
  const [selectDaySlot, setSelectDaySlot] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const [todayAndTomorrowDate, setTodayAndTomorrowDate] = useState<any>({
    today: "",
    tomorrow: "",
  });

  const storeId = storeInfo?.selectedStore?.store_id;
  Konsole.log("storeId", storeId);

  Konsole.log("todayAndTomorrowDate", storeInfo, todayAndTomorrowDate);

  // @@ return pickup date
  const returnStorePickupDate = useMemo(() => {
    return storeInfo?.storePickupDate;
  }, [storeInfo]);

  // @@ slots scroll by id
  useEffect(() => {
    const timer = setTimeout(() => {
      const selectedElement = document.getElementById(
        `slot-${selectedPickupTime}`
      );
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [deliveryScheduleAsapArr[1] === deliveryScheduleType, selectedPickupDate]);

  // @@ day scroll
  useEffect(() => {
    // @@ scroll day slots by id
    const time = setTimeout(() => {
      const selectDay = document.getElementById(
        `day-${selectedPickupDate?.date}`
      );
      if (selectDay) {
        selectDay.scrollIntoView({
          behavior: "smooth", // animation
          inline: "center", // ⬅️ keeps the card in the middle horizontally
          block: "nearest", // keeps vertical position unchanged
        });
      }
    }, 200);

    return () => clearTimeout(time);
  }, [selectedPickupDate, deliveryScheduleAsapArr[1] === deliveryScheduleType]);

  useEffect(() => {
    const time = setTimeout(() => {
      // @@ remove (if) condition due to update the current status of store

      // if (storeId && !storeInfo?.storePickupDate?.length) {
      GetPickupDate(dispatch, storeId);
      // }

      // Get today's date
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const todayDay = today.getDate();
      const tomorrowDay = tomorrow.getDate();
      setTodayAndTomorrowDate({ today: todayDay, tomorrow: tomorrowDay });

      //  if (!selectedPickupDate || !selectedPickupTime)
      // else {

      // if (returnStorePickupDate?.length > 0 && deliveryScheduleType == deliveryScheduleAsapArr[1] && (selectedPickupDate == '' || selectedPickupTime == '')) {
      // if (returnStorePickupDate?.length > 0 && (selectedPickupDate == '' || selectedPickupTime == '')) {
      //   handleSelectDate(returnStorePickupDate[0], 'useEffect')
      // }
    }, 200);

    return () => clearTimeout(time);

    // }
    // }
  }, [storeId, deliveryScheduleType]);

  // @@ radio for schedule and ASAP
  const handleDelivrySchAsap = (val: any) => {
    if (!returnStorePickupDate.length) {
      return;
    }
    dispatch(setDeliveryScheduleType(val));
    if (
      val == deliveryScheduleAsapArr[1] &&
      selectedPickupDate == "" &&
      selectedPickupTime == ""
    ) {
      let preselectDate;
      const now = new Date();
      const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
      for (let i = 0; i < returnStorePickupDate?.length; i++) {
        if (returnStorePickupDate[i]?.displayDay == "Today") {
          const avaiSlots = returnStorePickupDate[i]?.available_slots?.filter(
            (slot: any) => convertToMinutes(slot) > currentTimeInMinutes
          );
          if (avaiSlots?.length > 0) {
            preselectDate = returnStorePickupDate[i];
            break;
          }
        } else {
          if (returnStorePickupDate[i]?.available_slots?.length > 0) {
            preselectDate = returnStorePickupDate[i];
            break;
          }
        }
      }

      // handleSelectDate(returnStorePickupDate[0], val)
      handleSelectDate(preselectDate, val);
    }
  };

  // @@ set ASAP as default
  useEffect(() => {
    const time = setTimeout(() => {
      clearDateTimeSlot();
      handleDelivrySchAsap(deliveryScheduleAsapArr[0]);
    }, 100);
    // return clearTimeout(time)
  }, []);

  // @@ clear selected date and time
  const clearDateTimeSlot = () => {
    dispatch(setSelectedPickupDate(""));
    dispatch(setSelectedPickupTime(""));
  };
  // Function to convert 12-hour time format to minutes since midnight

  // @@ date selection and clear time
  const handleSelectDate = (item: any, val: any) => {
    dispatch(setSelectedPickupDate(item));
    dispatch(setSelectedPickupTime(""));
    // Konsole.log("itemavailableslots", item);
    let avaiSlots = item?.available_slots;

    // @@ filter only today slot
    if (item?.displayDay == "Today" || val == "useEffect") {
      const now = new Date();
      const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
      Konsole.log("currentTimeInMinutes", currentTimeInMinutes);
      if (isDeviceIos) {
        avaiSlots = item?.available_slots?.filter(
          (slot: any) => convertToMinutesIphone(slot) > currentTimeInMinutes
        );
      } else {
        avaiSlots = item?.available_slots?.filter(
          (slot: any) => convertToMinutes(slot) > currentTimeInMinutes
        );
      }
      // avaiSlots = item?.available_slots?.filter((slot: any) => convertToMinutes(slot) > currentTimeInMinutes);
    }

    setSelectDaySlot(avaiSlots);
    // @@ date change select slot
    handleSelectSlot(avaiSlots[0]);
    // scrollSlot();
  };
  // @@ select time slot
  const handleSelectSlot = (item: any, type?: any) => {
    setErrMsg("");
    dispatch(setSelectedPickupTime(item));
    // @@ for adding time close modal
    if (type == "cancel") {
      handleSchedule();
    }
  };

  // @@ cancel schedule and set ASAP
  const handleCancelSchedule = () => {
    if (!selectedPickupDate || !selectedPickupTime) {
      dispatch(setSelectedPickupDate(""));
      dispatch(setSelectedPickupTime(""));
      setErrMsg("");
      setSelectDaySlot([]);
      handleDelivrySchAsap(deliveryScheduleAsapArr[0]);
      return;
    }
    handleSchedule();
  };

  // @@ save schedule
  const handleSchedule = () => {
    if (!selectedPickupDate) {
      // ErrorToast("Please select Pickup date");
      setErrMsg("Please select pickup date");
      return;
    }
    if (!selectedPickupTime) {
      setErrMsg("Please select time slot");
      return;
    }
    handleDelivrySchAsap(deliveryScheduleAsapArr[0]);
  };

  // Function to scroll to an element by its ID
  const scrollSlot = () => {
    setTimeout(() => {
      const element = document.getElementById(selectedPickupTime);
      Konsole.log("elementelement", element);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }, 1);
  };

  // @@ return selected date and time slot
  const returnScheduleTimeLine = useMemo(() => {
    let str;
    if (selectedPickupDate && selectedPickupTime) {
      str = `${selectedPickupDate?.day} - ${selectedPickupTime}`;
    }
    return str;
  }, [selectedPickupDate, selectedPickupTime]);

  Konsole.log("returnStorePickupDate", returnStorePickupDate);
  return (
    <>
      {orderType == "delivery" ? (
        <div className="flex justify-between  md:mb-5 mt-4 ">
          <p className="text-xl font-splekta font-normal">
            {t("Checkout.deliveryOptions")}
          </p>
          <img src="/images/scooter-icon.svg" />
        </div>
      ) : (
        
        <div className="flex md:flex-row flex-col justify-between md:items-center md:mb-5">
          <p className="text-xl font-splekta font-normal">
            {t("Checkout.pickupAddress")}
          </p>
          <p className="textMd font-normal">
            {ReturnStoreAddress(storeInfo?.selectedStore)}
          </p>
        </div>
      )}
      <hr className="mt-4 mb-4 border-t-2 border-[#E2E2E2] md:mx-0 -mx-4" />
      <div className="chooseVariation w-full new-chooseVariation" style={{padding:"0px"}}>
        <div className="flex justify-between items-center cursor-pointer" onClick={() => {
          clearDateTimeSlot();
          handleDelivrySchAsap(deliveryScheduleAsapArr[0]);
        }}>
          <label htmlFor="asap cursor-pointer">
            <div className="variation_option textMd ">
              <p className="font-bold cursor-pointer">{t("Checkout.asap")}</p>
              <p className="font-normal text-[#4B4B4B] cursor-pointer">45-60 {t("Checkout.min")} </p>
            </div>
          </label>
          <input
            type="radio"
            checked={deliveryScheduleType == deliveryScheduleAsapArr[0]}
            onClick={() => {
              clearDateTimeSlot();
              handleDelivrySchAsap(deliveryScheduleAsapArr[0]);
            }}
            className="w-5 h-5 accent-black shrink-0 cursor-pointer"
            id="asap"
            name="deliveryOption"
          />

        </div>
      </div>
      
      <div className="chooseVariation w-full !border-none new-chooseVariation " style={{paddingBottom:"0px"}}>
        <div className="flex justify-between items-center cursor-pointer" onClick={() => handleDelivrySchAsap(deliveryScheduleAsapArr[1])}>
          <div className="" >
            <label htmlFor="schedule cursor-pointer">
              <div className="variation_option textMd ">
                <p className="font-bold cursor-pointer">{t("Checkout.schedule")}</p>
                 <p className="font-normal text-[#4B4B4B] cursor-pointer"> {returnScheduleTimeLine ? returnScheduleTimeLine : "Choose a time"} </p>
              </div>
            </label>
            {/* <p className="font-normal text-[#4B4B4B] cursor-pointer">
              {returnScheduleTimeLine ? returnScheduleTimeLine : "Choose a time"}
            </p> */}
          </div>
          <input
            type="radio"
            checked={
              deliveryScheduleType == deliveryScheduleAsapArr[1] ||
              selectedPickupDate != ""
            }
            className="w-5 h-5 accent-black shrink-0 cursor-pointer"
            onClick={() => handleDelivrySchAsap(deliveryScheduleAsapArr[1])}
            id="schedule"
            name="deliveryOption"
          />
        </div>

      </div>

      <Modal
        // ariaHideApp={false}
        className="new-modal-react md:!w-[30rem] w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden"
        isOpen={deliveryScheduleType == deliveryScheduleAsapArr[1]}
        onRequestClose={handleCancelSchedule}
        closeTimeoutMS={300}
        overlayClassName="modal-overlay"
        // contentLabel=""
        // open={deliveryScheduleType == deliveryScheduleAsapArr[1]}
        // onClose={handleCancelSchedule}
        // center
        // classNames={{
        //   overlay: "customOverlay",
        //   modal: "modalMd ",
        //   closeIcon: "modal-close",
        // }}
      >
        <div className="flex justify-between px-5 py-4 sticky top-0 bg-white z-50">
          <p className="font-splekta text-2xl ">
            {t("Checkout.scheduleDelivery")}
          </p>
          <button className="new-close-btn" onClick={handleCancelSchedule}>
            <svg
              className="modal-close"
              width="28"
              height="28"
              viewBox="0 0 36 36"
              data-testid="close-icon"
            >
              <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path>
            </svg>
          </button>
        </div>
        <div
          className={`px-5 h-[30rem]  ${
            mobile && iosDevice ? "slot-height-ios" : ""
          }`}
          //  className="px-5 h-[30rem]"
        >
          {/* @@ Map days  */}
          {returnStorePickupDate.length > 0 ? (
            <div className="flex gap-2 justify-between mb-7 overflow-x-auto scroll-hidden ">
              {returnStorePickupDate?.map((pDItem: any, pDIndex: number) => {
                Konsole.log("pDItem", pDItem);
                const findDate = pDItem?.short_date?.split(" ")[1];
                let displayDay = pDItem?.day?.slice(0, 3);

                if (findDate == todayAndTomorrowDate?.today) {
                  displayDay = "Today";
                } else if (todayAndTomorrowDate?.tomorrow == findDate) {
                  displayDay = "Tomorrow";
                }
                pDItem["displayDay"] = displayDay;
                Konsole.log("displayDay", displayDay, findDate);
                const selectDay = selectedPickupDate?.date === pDItem?.date;
                const now = new Date();
                const currentTimeInMinutes =
                  now.getHours() * 60 + now.getMinutes();
                if (pDItem?.displayDay == "Today") {
                  let avaiSlots = pDItem?.available_slots?.filter(
                    (slot: any) => convertToMinutes(slot) > currentTimeInMinutes
                  );
                  if (avaiSlots?.length < 1) {
                    return;
                  }
                }
                // else{
                //   if(pDItem?.available_slots.length < 1) return
                // }
                // console.log(pDItem,"pDItem")
                return (
                  <>
                    <button
                      disabled={
                        pDItem?.displayDay == "Today"
                          ? false
                          : pDItem?.available_slots.length < 1
                          ? true
                          : false
                      }
                      key={pDIndex}
                      // ref={selectDay ? selectDayRef : null}
                      id={`day-${pDItem?.date}`}
                      onClick={() => handleSelectDate(pDItem, "")}
                      className={` min-w-[100px] w-full text-left rounded-md p-3 ${
                        selectDay
                          ? "border border-black"
                          : "border border-[#E7E7E7]"
                      }
                   `}
                    >
                      <div className="font-medium textMd mb-2">
                        {displayDay}
                      </div>
                      <div className=" text-[#414141] textMd font-normal mb-2">
                        {pDItem?.short_date}
                      </div>
                    </button>
                  </>
                );
              })}
            </div>
          ) : null}

          {/* @@ error msg display */}
          {errMsg ? (
            <span className="text-[#ED2323] textMd font-normal">
              {" "}
              {errMsg}{" "}
            </span>
          ) : null}

          {selectDaySlot?.length > 0 ? (
            <>
              <div
                className="scroll-hidden h-[75%] md:h-65%]"
                style={{
                  overflowX: "hidden",
                  overflowY: "scroll",
                  WebkitOverflowScrolling: "touch",
                  paddingTop: "8px",
                  scrollBehavior: "smooth",
                }}
              >
                {selectDaySlot?.map((slItem: any, slIndex: number) => {
                  const isSelected = slItem == selectedPickupTime;
                  return (
                    <>
                      <div
                        id={slItem}
                        // id="SLOT_ID"
                        // ref={isSelected ? selectedSlotRef : null}
                        key={slIndex}
                        className="chooseVariation w-full new-chooseVariation "
                      >
                        <div
                          className="flex justify-between items-center cursor-pointer"
                          onClick={() => handleSelectSlot(slItem, "cancel")}
                        >
                          <label
                            htmlFor={`slot-${slItem}`}
                            className="flex items-center justify-between w-full cursor-pointer"
                          >
                            <div className="variation_option textMd">
                              <p className="font-medium">{slItem}</p>
                            </div>
                            <input
                              type="radio"
                              checked={isSelected}
                              className="w-5 h-5 accent-black shrink-0 cursor-pointer"
                              id={`slot-${slItem}`}
                              name="scheduleOption"
                            />
                          </label>
                        </div>
                        {/* <div className="flex justify-between items-center cursor-pointer" onClick={() => handleSelectSlot(slItem)}>
                          <label htmlFor={slItem}>
                            <div className="variation_option textMd ">
                              <p className="font-medium">{slItem}</p>
                            </div>
                          </label>
                          <input
                            type="radio"
                            // checked={slItem == selectedPickupTime}
                            checked={isSelected}
                            // onChange={() => handleSelectSlot(slItem)}
                            className="w-5 h-5 accent-black shrink-0 cursor-pointer"
                            id={slot-${slItem}}
                            name="scheduleOption"
                          />

                        </div>  */}
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          ) : null}
        </div>

        {/* <div className="fixed bottom-0 w-full md:px-5 p-3 md:py-4 z-50 bg-white">
          <button
            className="btn-secondary w-full mb-3"
            onClick={() => handleSchedule()}
          >
            {t("Checkout.schedule")}
          </button>
          <button
            className="btn-border-sky w-full"
            onClick={handleCancelSchedule}
          >
            {t("VerifyOtp.cancel")}
          </button>
        </div> */}
      </Modal>
    </>
  );
};

export default DeliveryOption;
